/**
 * File normalization utilities
 */
import type { File } from '@/types/File'

import { formatFileSize } from './formatters'

/**
 * Normalized file structure used across all opportunity types
 */
export interface NormalizedFile {
  id: string
  name: string
  url: string
  pdfUrl: string | null
  contentType: string | null
  type: File['type']
  size: number | null
  sizeFormatted: string | null
  summary: string | null
  createdAt: string
}

/**
 * Normalize an array of files into a consistent structure
 * Uses the File type from @/types/File
 */
export function normalizeFiles(
  files: File[] | null | undefined,
): NormalizedFile[] {
  if (!files) return []

  return files.map((file) => ({
    id: file.id,
    name: file.name,
    url: file.url,
    pdfUrl: file.pdf_url ?? null,
    contentType: file.content_type ?? null,
    type: file.type,
    size: file.size ?? null,
    sizeFormatted: formatFileSize(file.size),
    summary: file.summary ?? null,
    createdAt: file.created_at,
  }))
}
